import { TextStyle } from '../chart-legend/text-style';

export class VAxis {
    title?: string;
    minValue?: string;
    maxValue?: string;
    textStyle?: TextStyle = new TextStyle();
}